import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cgu-app',
  templateUrl: './cgu-app.component.html',
  styleUrls: ['./cgu-app.component.scss']
})
export class CguAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
